import { Component, inject } from '@angular/core';
import { CadastralSectionService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  CadastralSectionCreateDto,
  CadastralSectionDto,
  CadastralSectionExcelDownloadDto,
  CadastralSectionUpdateDto,
} from '../proxy/planning/dtos/cadastral-section';
import { CADASTRALSECTION_CONFIG, CADASTRALSECTION_FIELDS } from './cadastral-section.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-cadastral-section',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, CadastralSectionService, ConfirmationService],
  templateUrl: './cadastral-section.html',
  styleUrl: './cadastral-section.scss',
})
export class CadastralSection extends BaseHierarchicalCrudComponent<
  CadastralSectionDto,
  CadastralSectionCreateDto,
  CadastralSectionUpdateDto,
  CadastralSectionExcelDownloadDto
> {
  service = inject(CadastralSectionService);
  config = CADASTRALSECTION_CONFIG;
  fields = CADASTRALSECTION_FIELDS;

  protected prepareUpdateDto(data: any, selected: CadastralSectionDto): CadastralSectionUpdateDto {
    return {
      name: data.name,
      code: data.code,
      locationId: data.locationId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'CadastralSection';
  }
}
